import { Component, EventEmitter, input, Output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { Constants } from "../../../constants/constants";
import { DashboardProjectModel } from "../../../models";
import { PictureComponent, ProgressIndicatorComponent } from "../../general";

@Component({
  selector: "adaa-tp-project-card",
  imports: [TranslatePipe, TranslateTokenPipe, ProgressIndicatorComponent, PictureComponent],
  templateUrl: "./tp-project-card.html",
  styleUrl: "./tp-project-card.scss",
})
export class TpProjectCardComponent {
  project = input.required<DashboardProjectModel>();
  showTargetsProgressBar = input<boolean>(true);

  readonly achievementColor = Constants.CONSTANT_COLORS.EVALUATION_GOLD;

  @Output() cardClicked = new EventEmitter<number>();
}
